import React, { useEffect, useState } from 'react';
import { database } from '../firebaseConfig';
import { ref, onValue, push, update } from 'firebase/database';

// Admin review of insurance providers agents asked to have added to the partner list.
// Approve adds the provider to partners; reject just marks the request.
export default function PartnerRequests() {
  const [requests, setRequests] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    const unsubscribe = onValue(ref(database, 'partnerRequests'), (snap) => {
      const val = snap.val() || {};
      setRequests(
        Object.entries(val)
          .map(([id, r]) => ({ id, ...r }))
          .filter((r) => r.status === 'pending')
          .sort((a, b) => (a.createdAt || '').localeCompare(b.createdAt || ''))
      );
    }, (err) => {
      console.error(err);
      setError('Could not load partner requests.');
    });
    return () => unsubscribe();
  }, []);

  const approve = async (r) => {
    const { id, status, requestedBy, requestedByName, createdAt, ...partner } = r;
    await push(ref(database, 'partners'), { ...partner, partnerType: 'Insurance' });
    await update(ref(database, `partnerRequests/${id}`), { status: 'approved', decidedAt: new Date().toISOString() });
  };

  const reject = async (r) => {
    await update(ref(database, `partnerRequests/${r.id}`), { status: 'rejected', decidedAt: new Date().toISOString() });
  };

  if (!requests.length && !error) return null;

  const btn = { padding: '6px 12px', borderRadius: 6, border: 'none', fontWeight: 600, cursor: 'pointer', marginRight: 8 };

  return (
    <div style={{ marginBottom: 20, padding: 16, border: '1px solid #D4AF37', borderRadius: 8, background: '#FFFFFF' }}>
      <h3 style={{ margin: '0 0 8px', fontSize: 16 }}>Partner requests to approve</h3>
      {error && <p style={{ color: '#b00020', fontSize: 14 }}>{error}</p>}
      {requests.map((r) => (
        <div key={r.id} style={{ padding: '10px 0', borderTop: '1px solid #E1E4EA' }}>
          <div style={{ fontSize: 14, fontWeight: 600 }}>{r.companyName} - {r.firstName} {r.lastName}</div>
          <div style={{ fontSize: 13, color: '#5B6270' }}>{r.phone} {r.email && `| ${r.email}`} | Requested by {r.requestedByName || 'an agent'}</div>
          <div style={{ marginTop: 6 }}>
            <button type="button" onClick={() => approve(r)} style={{ ...btn, background: '#2e7d32', color: '#FFFFFF' }}>Approve</button>
            <button type="button" onClick={() => reject(r)} style={{ ...btn, background: '#FFFFFF', color: '#5B6270', border: '1px solid #D5D9E0' }}>Reject</button>
          </div>
        </div>
      ))}
    </div>
  );
}
